import SystemAlerts from './SystemAlerts';

export default SystemAlerts;
